import AppForm from '../app-components/Form/AppForm';

var userLanguage = document.documentElement.lang;

Vue.component('maternity-leave-form', {
    mixins: [AppForm],
    props: {
        'trans': {
            //type: Array,
            required: false,
            default: function(){
                return [];
            },
        },
        'employeeId': {
            type: Number
        },
        'maternityLeavesTypes': {
            type: Array,
        },
    },
    data: function() {
        return {
            form: {
                employee_id: this.employeeId,
                type: 1,
                date_start: '',
                date_end: '',
            },
            datePickerConfig: {
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd.m.Y',
                locale: userLanguage
            },
        }
    },

    methods: {
        preventSubmit(event){
            if (event) event.preventDefault();
            if (event) event.stopPropagation();
        },

        getPostData() {
            this.form = {
                ...this.form,
            };

            return this.form;
        },

        onSuccess(data) {
            this.submiting = false;
            this.$root.$emit('updatematernityleavesgrid');
            this.$modal.hide('maternity-leave-form');
            this.$notify({ type: 'success', title: '<span class="fa fa-check"></span>', text: data.message });
        },

        onFail: function onFail(errors) {
            this.submiting = false;
            var bag = this.$validator.errors;
            bag.clear();
            Object.keys(errors).map(function (key) {
                bag.add({ field: key, msg: errors[key][0] });
            });
        },
    },
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/maternity-leave/Form.js